<template>
    <div class="card-pre-offer">
        <h5 class="card-pre-offer-title">Previsualización</h5>
        <div class="dummy-offer">
            <div class="preview-data">
                <p class="title" v-if="!offer.name">Título de tu contenido</p>
                <p class="title" v-else>{{offer.name}}</p>
                <p class="subtitle" v-if="!offer.description">Descripción de tu contenido</p>
                <p class="subtitle" v-else>{{offer.description}}</p>
                <div class="button md secondary">
                    <p v-if="!offer.button_text">Texto del botón</p>
                    <p v-else>{{offer.button_text}}</p>
                </div>
            </div>
            <span class="default-image" v-if="!offer.images&&!offer.preview"></span>
            <div class="offer-img-container" :style="{backgroundImage: 'url('+offer.preview+')'}" v-else-if="offer.preview"></div>
            <div class="offer-img-container" :style="{backgroundImage: 'url('+imgPreview+')'}" v-else></div>
        </div>
        <div class="categories">
                <ul>
                  <li class="category-dummy" :class="offer.category == 1 ? 'active' : ''">
                    <span class="img-cat category-1" :class="offer.category == 1 ? 'active-cat-1' : ''"></span>
                    <p class="category-name">{{ category_1 }}</p>
                  </li>
                  <span class="divider"></span>
                  <li class="category-dummy" :class="offer.category == 2 ? 'active' : ''">
                    <span class="img-cat category-2" :class="offer.category == 2 ? 'active-cat-2' : ''"></span>
                    <p class="category-name">{{ category_2 }}</p>
                  </li>
                  <span class="divider" v-if="category_3"></span>
                  <li class="category-dummy" :class="offer.category == 3 ? 'active' : ''" v-if="category_3">
                    <span class="img-cat category-3" :class="offer.category == 3 ? 'active-cat-3' : ''"></span>
                    <p class="category-name">{{ category_3 }}</p>
                  </li>
                  <span class=  "divider" v-if="category_4"></span>
                  <li class="category-dummy" :class="offer.category == 4 ? 'active' : ''" v-if="category_4">
                    <span class="img-cat category-4" :class="offer.category == 4 ? 'active-cat-4' : ''"></span>
                    <p class="category-name">{{ category_4 }}</p>
                  </li>
                </ul>
            </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'PreOfferCard',
    data: function(){
      return {
        category_1: process.env.VUE_APP_CATEGORY_1,
        category_2: process.env.VUE_APP_CATEGORY_2,
        category_3: process.env.VUE_APP_CATEGORY_3,
        category_4: process.env.VUE_APP_CATEGORY_4,
      }
    },
    computed: {
        ...mapGetters('offers', [
            'getDummyOffer'
        ]),
        offer: function() {
            return this.getDummyOffer
        },
        imgPreview: function(){
            return process.env.VUE_APP_CORE_HOST + this.offer.images
        }
    }
}
</script>

<style lang="sass">
.card-pre-offer
    width: calc(100% - 24px)
    padding: 0 8px
    min-width: 378px
    @include tablet-portrait
      min-width: 200px
    @include tablet-landscape
      min-width: 200px
    background: #ffffff
    border-radius: 4px
    border: solid 1px #e5edf4
    text-align: center
    height: 630px
.card-pre-offer-title
    margin-top: 8px
    margin-bottom: 32px
    text-align: left
    display: block
.dummy-offer
    width: 100%
    max-width: 351px
    height: 460px
    margin: 0 auto 16px
    border-radius: 8px
    background-color: #d0d0d0
    position: relative
    overflow: hidden
    display: grid
    grid-template-row: 1fr
    grid-template-column: 1fr
    .default-image
        position: absolute
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        background: #d3dce1 
        background-size: 48px 48px
        background-image: url(../../assets/icons/default-image.svg)
        background-position: center
        background-repeat: no-repeat
    img
        width: 100%
        height: 100%
    .offer-img-container
        position: absolute
        width: 100%
        height: 100%
        z-index: 1
        background-position: center center
        background-size: cover
    .preview-data
        height: 100%
        width: 100%
        display: flex
        flex-direction: column
        justify-content: flex-end
        align-items: center
        font-family: $body-font
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.75) 72%)
        z-index: 2
        .title
            font-weight: bold
            font-size: 24px
            text-align: right
            width: 100%
            color: $white
            order: 1
            padding: 0px 8px
            box-sizing: border-box
            margin-bottom: 0px
        .subtitle
            text-align: right
            width: 100%
            font-weight: 200
            color: $white
            order: 2
            font-size: 16px
            padding: 0px 8px
            margin-top: $xs
            margin-bottom: $md
            box-sizing: border-box
        .button
            order: 3
            margin-bottom: $sm
            width: 60%
.categories
    display: flex
    flex-direction: row
    align-items: center
    width: 100%
    background: $white
    margin-top: $sm
    ul
      display: flex
      justify-content: space-evenly
      width: 100%
      align-items: flex-start
      list-style-type: none
      align-self: center
      background-color: $white
      padding: 4px
      li
        align-items: center
        .img-cat
          width: 32px
          height: 32px
          display: block
          background-position: 0% 0% 
          margin-bottom: $xs
        .category-1
          background: url(../../assets/icons/categories/cat-01-in.svg) no-repeat center
        .category-2
          background: url(../../assets/icons/categories/cat-02-in.svg) no-repeat center
        .category-3
          background: url(../../assets/icons/categories/cat-03-in.svg) no-repeat center
        .category-4
          background: url(../../assets/icons/categories/cat-04-in.svg) no-repeat center
        .active-cat-1
          background: url(../../assets/icons/categories/cat-01-ac.svg) no-repeat center
        .active-cat-2
          background: url(../../assets/icons/categories/cat-02-ac.svg) no-repeat center
        .active-cat-3
          background: url(../../assets/icons/categories/cat-03-ac.svg) no-repeat center
        .active-cat-4
          background: url(../../assets/icons/categories/cat-04-ac.svg) no-repeat center
    .divider
      width: 1px
      height: 24px
      border: none
      display: flex
      background: $secondary
      border-radius: 8px
    .category-dummy
      flex-grow: 1
      display: flex
      flex-direction: column
      opacity: 0.6
      width: 30%
      .category-name
        font-family: $title-font
        font-size: 10px
        text-align: center
        font-weight: bold
      &.active
        color: $secondary
        opacity: 0.6







</style>